import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    {
        path: '',
        title: 'Home',
        icon: 'mdi mdi-home-variant',
        class: 'nav-small-cap',
        extralink: true,
        submenu: []
    },
    {
        path: '/admin',
        title: 'Dashboard',
        icon: 'mdi mdi-view-dashboard',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Applicants',
        icon: 'mdi mdi-dots-horizontal',
        class: 'nav-small-cap',
        extralink: true,
        submenu: []
    },
    {
        path: '/admin/applicants',
        title: 'Applicants list',
        icon: 'mdi mdi-account-box',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '/admin/applicants/create',
        title: 'Create new applicant',
        icon: 'mdi mdi-account-plus',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '/admin/upload',
        title: 'Upload applicants',
        icon: 'mdi mdi-upload',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Courses',
        icon: 'mdi mdi-dots-horizontal',
        class: 'nav-small-cap',
        extralink: true,
        submenu: []
    },
    {
        path: '/admin/courses',
        title: 'Courses list',
        icon: 'mdi mdi-book',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '/admin/courses/create',
        title: 'Create new course',
        icon: 'mdi mdi-book-plus',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Instructors',
        icon: 'mdi mdi-dots-horizontal',
        class: 'nav-small-cap',
        extralink: true,
        submenu: []
    },
    {
        path: '/admin/instructors',
        title: 'Instructors list',
        icon: 'mdi mdi-school',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '/admin/instructors/create',
        title: 'Create new instructor',
        icon: 'mdi mdi-account-plus',
        class: '',
        extralink: false,
        submenu: []
    },
    {
        path: '',
        title: 'Account',
        icon: 'mdi mdi-dots-horizontal',
        class: 'nav-small-cap',
        extralink: true,
        submenu: []
    },
    {
        path: '/admin/account',
        title: 'Change password',
        icon: 'mdi mdi-account-key',
        class: '',
        extralink: false,
        submenu: []
    }
];
